import { motion } from 'framer-motion';
import { Clock, ListChecks } from 'lucide-react';

const HomeScreen = ({ onStart }) => {
  const stagger = {
    animate: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
  };
  const item = {
    initial: { opacity: 0, y: 14 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <motion.div
      variants={stagger}
      initial="initial"
      animate="animate"
      className="flex-1 flex flex-col items-center justify-center px-8 sm:px-16 py-12 text-center max-w-4xl mx-auto w-full"
    >
      <motion.img
        variants={item}
        src="/logo.png"
        alt="Healthy Life Vitamins"
        className="w-72 sm:w-80 h-auto object-contain mb-4 drop-shadow-sm"
      />

      <motion.div
        variants={item}
        className="text-[11px] uppercase tracking-[0.4em] font-bold text-[#1f3d2b]/70 mb-12 flex items-center gap-3"
      >
        <span className="block w-8 h-px bg-[#1f3d2b]/30" />
        Wellness Club
        <span className="block w-8 h-px bg-[#1f3d2b]/30" />
      </motion.div>

      <motion.h1
        variants={item}
        className="text-5xl sm:text-6xl text-[#0d1f15] mb-6 leading-[1.05] tracking-tight max-w-2xl"
        style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
      >
        Find Your Personalized<br />Vitamin Plan
      </motion.h1>

      <motion.p
        variants={item}
        className="text-lg sm:text-xl text-[#5a7062] max-w-xl mb-12 leading-relaxed"
        style={{ fontFamily: "'Manrope', sans-serif" }}
      >
        Answer a few quick questions and we'll match you with the right
        supplements — backed by your goals, sleep, stress and recovery.
      </motion.p>

      <motion.div variants={item} className="flex items-center gap-3 mb-8">
        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#1f3d2b]/70 bg-white/70 backdrop-blur px-4 py-2 rounded-full border border-[#1f3d2b]/10">
          <Clock size={14} strokeWidth={2.5} /> ~ 90 sec
        </span>
        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#1f3d2b]/70 bg-white/70 backdrop-blur px-4 py-2 rounded-full border border-[#1f3d2b]/10">
          <ListChecks size={14} strokeWidth={2.5} /> 12 questions
        </span>
      </motion.div>

      <motion.button
        variants={item}
        data-testid="kiosk-start-button"
        onClick={onStart}
        animate={{ scale: [1, 1.06, 1] }}
        transition={{ scale: { duration: 2, repeat: Infinity, ease: 'easeInOut' } }}
        whileTap={{ scale: 0.96 }}
        className="bg-[#1f3d2b] text-white rounded-full px-14 sm:px-16 py-6 text-lg sm:text-xl tracking-tight shadow-[0_12px_40px_rgba(31,61,43,0.25)] active:bg-[#152e20] inline-flex items-center justify-center"
        style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, minHeight: 72 }}
      >
        Tap to Start
      </motion.button>
    </motion.div>
  );
};

export default HomeScreen;
